import React from 'react';
import { FaArrowLeft, FaProjectDiagram, FaEye, FaEyeSlash } from 'react-icons/fa';
import { BiRadar } from 'react-icons/bi';
import { TREE_CHART_MODES } from '../../../../constants/radar';
import {
  HeaderWrapper,
  HeaderLeft,
  BackButton,
  Title,
  ViewSwitchButton,
  ViewSwitchIcon,
  HeaderRight
} from './styles';

const Header = ({ 
  onBack, 
  title = "Technology Radar",
  showViewSwitch = false,
  chartType,
  onViewSwitch,
  isPanelsVisible,
  onTogglePanels,
  backButtonText = "Back to Home"
}) => {
  return (
    <HeaderWrapper>
      <HeaderLeft>
        <BackButton onClick={onBack}>
          <FaArrowLeft /> {backButtonText}
        </BackButton>
        <Title>{title}</Title>
      </HeaderLeft>
      <HeaderRight>
        {showViewSwitch && (
          <ViewSwitchButton onClick={onViewSwitch}>
            {chartType === TREE_CHART_MODES.TREE ? (
              <>
                <ViewSwitchIcon>
                  <BiRadar />
                </ViewSwitchIcon>
                Switch to Radar View
              </>
            ) : (
              <>
                <ViewSwitchIcon>
                  <FaProjectDiagram />
                </ViewSwitchIcon>
                Switch to Tree View
              </>
            )}
          </ViewSwitchButton>
        )}
        {showViewSwitch && (
          <ViewSwitchButton onClick={onTogglePanels}>
            <ViewSwitchIcon>
              {isPanelsVisible ? <FaEyeSlash /> : <FaEye />}
            </ViewSwitchIcon>
            {isPanelsVisible ? 'Hide Panels' : 'Show Panels'}
          </ViewSwitchButton>
        )}
        
      </HeaderRight>
    </HeaderWrapper>
  );
};

export default Header; 